import { IUIConfig } from '@interfaces/ui-config';
import { useTheme } from 'next-themes';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function Logo() {
  const { theme = 'light' } = useTheme();
  const { darkmodeLogo, logo, siteName }: IUIConfig = useSelector((state: any) => state.ui);
  const [logoImage, setLogo] = useState(logo);

  useEffect(() => {
    if (theme === 'dark' && darkmodeLogo) {
      setLogo(darkmodeLogo);
    } else if (theme === 'light' && logo) {
      setLogo(logo);
    }
  }, [theme, darkmodeLogo, logo]);

  return (
    <Link href="/home">
      {logoImage ? (
        <Image
          alt="logo"
          width={150}
          height={35}
          quality={70}
          priority
          sizes="(max-width: 768px) 50vw, (max-width: 2100px) 15vw"
          src={logoImage}
        />
      ) : siteName}
    </Link>
  );
}

export default Logo;
